import { CloseOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Col, Row } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const SingleGift = ({ GiftDetails }, props): ReactElement => {
  const [getGiftDetails, setGiftDetails] = useState(undefined);
  const [selectedProducts, setSelectedProducts] = useState(
    GiftDetails?.products
  );

  useEffect(() => {
    setGiftDetails(GiftDetails);
  }, [GiftDetails]);

  return (
    <React.Fragment>
      <Row gutter={5}>
        <Col span={24} style={{ background: "#fff" }}>
          <div className="">
            <h3 className="title">Basic Information</h3>
            <div className="mb-5">
              <div className="inner-body">
                <div className="single">
                  <div className="info-name">
                    <span>Starting Time</span>
                  </div>
                  <div className="info-desc">
                    <span>
                      {moment(getGiftDetails?.createdAt).format("lll")}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <div className="info-name">
                    <span>From Amount</span>
                  </div>
                  <div className="info-desc">
                    <span>{getGiftDetails?.fromAmount}</span>
                  </div>
                </div>

                <div className="single">
                  <div className="info-name">
                    <span>To Amount</span>
                  </div>
                  <div className="info-desc">
                    <span>{getGiftDetails?.toAmount}</span>
                  </div>
                </div>
              </div>
            </div>

            {selectedProducts && (
              <Row gutter={10}>
                <Col span={24}>
                  <h4 className="title mb-0">Gift Item(s)</h4>
                </Col>
                {selectedProducts?.map((product, index) => (
                  <Col span={12}>
                    <Card
                      className="mt-4"
                      title={product?.name}
                      key={index}
                      size="small"
                    >
                      <Avatar size={150} src={product?.productImage} />
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SingleGift.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SingleGift;
